/* eslint-disable @typescript-eslint/ban-types */
import React from 'react';
import { Row } from 'react-table';

import { IconCaret } from '../..';

interface RowExpanderCellProps<D extends object> {
    row: Row<D>;
}

const iconWidth = 16;
const iconFillColor = 'black';

/* eslint-disable react/jsx-props-no-spreading */

/**
 * Returns a cell that can expand the contents of a row. Must be used within a useTable call that
 * uses the useExpanded hook.
 * @param {RowExpanderCellProps} props
 */
export function RowExpanderCell<D extends object>({
    row,
}: RowExpanderCellProps<D>): JSX.Element {
    return (
        <span
            {...row.getToggleRowExpandedProps()}
            className="pl-2 respond-to-mouse"
        >
            <IconCaret
                width={iconWidth}
                fillColor={iconFillColor}
                rotation={row.isExpanded ? 0 : 270}
            />
        </span>
    );
}
